type GetUpdatedRowsArg = {
  currentRow: number
  rowPosition: number
  options: string[]
  tableId: string
  totalRows: number
  values: APIMeta[]
}

export const getUpdatedRows = (arg: GetUpdatedRowsArg) => {
  const { currentRow, rowPosition, options, tableId, totalRows, values } = arg

  if (currentRow === rowPosition) {
    const newRows = options.map(rowKey => {
      const newRow: APIMeta = {
        key: tableId,
        value: '',
        row: totalRows - 1,
        row_key: rowKey
      }

      return newRow
    })

    return newRows
  }

  if (currentRow > rowPosition) {
    const newRowIdx = currentRow - 1

    const newRows = options.map(rowKey => {
      const existingCell = values.find(item => item.row_key === rowKey)

      const newRow = {
        key: tableId,
        value: existingCell ? existingCell.value : '',
        row: newRowIdx,
        row_key: rowKey
      }

      return newRow
    })

    return newRows
  }

  return values
}
